<template>
    <v-menu
        :close-on-content-click="false"
        v-model="menu1"
        :nudge-right="160"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
        :disabled="isDisabled"
    >
        <v-text-field
            ref="date"
            slot="activator"
            v-model="dateFormatted"
            :label="label"
            hint="формат ДД.ММ.ГГГГ"
            @input.native="maskDate"
            @blur="date = parseDate(dateFormatted, max)"
            return-masked-value
            :rules="isRequired ? (isDisabled ? [] : dateRules) : []"
            :class="inputClass"
            :disabled="isDisabled"
        >
            <template slot="append">
                <div class="calendar"></div>
                <!--<img :src="calendarSrc" style="width: 17px; height: 21px;"/>-->
            </template>
        </v-text-field>
        <v-date-picker
            ref="tf"
            v-model="date"
            no-title
            actions
            @input="menu1 = false"
            locale="ru"
            first-day-of-week="1"
            :min="minDate"
            :max="max"
            :disabled="isDisabled"
            :class="isHideMobile ? 'hide-date-picker-mobile' : ''"
        >
        </v-date-picker>
    </v-menu>
</template>

<style scoped>
    .calendar {
        background: url('/svg/calendar.svg') no-repeat center;
        width: 17px;
        height: 21px;
        background-size: 18px 19px;
    }

    .error--text div.calendar {
        background-image: url('/svg/calendar_red.svg');
    }
</style>

<script>
    import moment from "moment";

    export default {
        props: {
            value: {},
            label: {
                default: 'Дата начала'
            },
            inputClass: '',
            isDisabled: {
                default: false
            },
            isRequired: {
                default: true
            },
            isBirthday: {
                default: false
            },
            isFirstLicense: {
                default: false
            },
            licenseAgeCheck: {
                default: false
            },
            passportAgeCheck: {
                default: false
            },
            yearStarting: {
                default: true
            },
            min: {
                default: "1920-01-01"
            },
            max: {
                default: "2099-12-31"
            },
            isHideMobile: {
                default: false
            },
            // для даты выдачи прав этот параметр болжен быть включен, т.к. она не может быть первого января
            restrictJan1: {
                default: false
            },
            isCallDate: {
                default: false
            }
        },
        data: function () {
            return {
                date: '', //new Date().toISOString().substr(0, 10),
                dateFormatted: '', //vm.formatDate(new Date().toISOString().substr(0, 10)),
                menu1: false,
                major: false,
                dateRules: [
                    v => !!v || 'Обязательное поле',
                    v => this.isDateValid(v, this.isBirthday, this.licenseAgeCheck, this.passportAgeCheck),
                ]
            }
        },
        mounted: function () {
            if (this.isCallDate) {
                this.date = this.value ? this.value : null;
            } else {
                this.date = this.value ? this.value : '';
            }

            if (this.yearStarting) {
                this.$refs.tf.activePicker = 'YEAR';
            }
        },
        computed: {
            minDate() {
                return this.min || "1920-01-01";
            }
        },
        watch: {
            value(val) {
                if (this.isFirstLicense && val < this.min) {
                    this.date = this.min;
                    return;
                }
                this.date = val;
            },
            date(val) {
                this.dateFormatted = this.formatDate(val, this.max, this.minDate);
                this.$emit("input", val);
                this.$emit("change", val);
                if (this.yearStarting) {
                    this.$refs.tf.activePicker = 'YEAR';
                }
            },
            licenseAgeCheck(val) {
                this.$refs.date.validate();
            },
            passportAgeCheck(val) {
                this.$refs.date.validate();
            },
        },
        methods: {
            formatDate(date, max, min) {
                if (!date) return null;
                if (this.isFirstLicense && date < min) {
                    date = min;
                }
                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            },
            parseDate(date, max) {
                if (!date) return null;
                const [day, month, year] = date.split('.');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            isDateValid(dateString, isBirthday, licenseAgeCheck, passportAgeCheck) {
                let m = moment(dateString, "DD.MM.YYYY");
                let isValid = m.format("DD.MM.YYYY") === dateString;
                if (!isValid) return "Неверный формат даты";

                if (isBirthday) {
                    if (moment().diff(m, 'years') < 14) return "Меньше 14 лет"
                }

                if (licenseAgeCheck) {
                    let d = moment(licenseAgeCheck, "YYYY-MM-DD");
                    if (m.diff(d, 'years') > 0) return "Меньше 16 лет";
                }

                if (passportAgeCheck) {
                    let d = moment(passportAgeCheck, "YYYY-MM-DD");
                    if (m.diff(d, 'years') < 0) return "Меньше 14 лет";
                }

                if (m.format("YYYY-MM-DD") > this.max) {
                    return "Должна быть меньше " + this.max.split('-').reverse().join('.');
                }

                if (m.format("YYYY-MM-DD") < this.minDate) {
                    return "Должна быть позднее " + this.minDate.split('-').reverse().join('.');
                }

                if (this.restrictJan1 && m.date() === 1 && m.month() === 0) {
                    return "Дата не может быть 1 января";
                }

                return false;
            },
            maskDate(e) {
                let caret_position = e.target.selectionStart;
                const lastAmountOfSeparators = (e.target.value.match(/[.]/g) || []).length;
                let replacedInput = e.target.value.replace(/\D/g, "").match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
                let formattedValue = !replacedInput[2]
                    ? replacedInput[1]
                    : replacedInput[1] + "." + replacedInput[2] + (replacedInput[3] ? "." + replacedInput[3] : "");

                if (formattedValue === e.target.value) {
                    return;
                }

                this.dateFormatted = formattedValue;
                const newAmountOfSeparators = (formattedValue.match(/[.]/g) || []).length;
                caret_position += newAmountOfSeparators - lastAmountOfSeparators;

                this.$nextTick(() => {
                    e.target.setSelectionRange(caret_position, caret_position);
                });
            }
        }
    }
</script>

<style scoped>
    @media(max-width: 600px){
        .hide-date-picker-mobile{
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/fields/Date.vue